/// <amd-module name="SuiteCommerce.SizeChart.PDP.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.PDP.Item.Model", ["require", "exports", "Backbone", "SuiteCommerce.SizeChart.Common.Utils"], function (require, exports, Backbone_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemFields;
    (function (ItemFields) {
        ItemFields["sizeChartId"] = "custitem_ns_sc_ext_sich_size_chart_id";
        ItemFields["sizeChartName"] = "custitem_ns_sc_ext_sich_size_chart";
    })(ItemFields = exports.ItemFields || (exports.ItemFields = {}));
    var PDPItemModel = /** @class */ (function (_super) {
        __extends(PDPItemModel, _super);
        function PDPItemModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PDPItemModel.prototype, "sizeChartId", {
            get: function () {
                return this.get(ItemFields.sizeChartId);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPItemModel.prototype, "sizeChartName", {
            get: function () {
                return this.get(ItemFields.sizeChartName) || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPItemModel.prototype, "sizeChartURLComponent", {
            get: function () {
                return Utils_1.Utils.getURLComponent(this.sizeChartName);
            },
            enumerable: true,
            configurable: true
        });
        PDPItemModel.prototype.hasSizeChart = function () {
            return !!(this.sizeChartId && this.sizeChartName);
        };
        return PDPItemModel;
    }(Backbone_1.Model));
    exports.PDPItemModel = PDPItemModel;
});
